export default __webpack_public_path__ + "images/assets/f49b59fc01a585749da86f94a7e8a49d.svg";